import { Injectable } from '@angular/core';

/**
 * Because Window is an typescript interface. You need to trick a compiler by creating a fake class
 * https://en.it1352.com/article/1925802.html
 */
@Injectable({
    providedIn: 'root',
})
export class WindowRef {
    get nativeWindow(): Window & typeof globalThis {
        return window;
    }

    get isLocalhost(): boolean {
        return window.location.host.includes('localhost');
    }
}
